import React from "react";
import CONSTS from "./pj-constants";



function PJJourneyNav(props) {

    return  (
            <div className="journey-nav container">
                <div className="row">
                    {props.backClick &&
                        <div className="left-container col-sm-3 col-xs-5 mb-auto">
                            <div className="go-back-button wp-block-button aligncenter is-style-outline">
                                <button onClick={props.backClick}  className="wp-block-button__link has-text-color has-light-red-color arrow-back">Go back</button>
                            </div>
                        </div>
                    }


                    <div className={"middle-container my-auto col-xs-2 col-sm-" + ((props.middleSize)?props.middleSize:'6')}>

                    </div>

                    {props.continueClick &&
                        <div className={"right-container my-auto text-right col-xs-5 col-sm-" + ((props.continueSize)?props.continueSize:'3')}>
                            <div className="continue-button wp-block-button aligncenter is-style-outline has-white-background-color">
                                <button onClick={props.continueClick} className="wp-block-button__link has-text-color has-light-red-color has-white-background-color">{ props.continueLabel ? props.continueLabel : 'Continue'}</button>
                            </div>
                            {props.continueExtra}
                        </div>
                    }
                </div>
            </div>
    );
}

export { PJJourneyNav };